import React from 'react'

const DevelopmentTeamsLikeVarahiSoft = ({ data }) => {
    return (
        <div>
            <h4 className="heading">{data?.heading}</h4>
            {data?.paragraph?.map((item, index) => {
                return (
                    <div key={index} className='mb-3'>
                        <p className="paragraph m-0">{item?.text}<b>{item?.boldText}</b>{item?.text1}</p>
                        {item?.list?.length > 0 &&
                            <ul className="mt-3 page-custom-made-application-list">
                                {item.list.map((li, liIndex) => {
                                    return (<li key={liIndex}>
                                        {li?.text && <p className="paragraph m-0"><b>{li?.boldText}</b>{li?.text} </p>}
                                    </li>
                                    )
                                })}
                            </ul>
                        }
                    </div>
                )
            })}
            <div>
            </div>
        </div>
    )
}
export default DevelopmentTeamsLikeVarahiSoft
